module.exports = __webpack_public_path__ + "img/shamanic_tent_small.0c4400ef.png";